import { Result } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { AButton } from '../../components';

type AccessDeniedLocationState = {
  from?: string;
};

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as AccessDeniedLocationState | null;

  return (
    <Result
      status="403"
      title="403"
      subTitle={
        state?.from
          ? `Você não tem permissão para acessar a rota ${state.from}.`
          : 'Você não tem permissão para acessar esta área.'
      }
      extra={[
        <AButton key="back" type="default" onClick={() => navigate(-1)}>
          Voltar
        </AButton>,
        <AButton
          key="dashboard"
          type="primary"
          onClick={() => navigate('/dashboard')}
        >
          Ir para o Dashboard
        </AButton>,
      ]}
    />
  );
};

export default AccessDenied;
